import clsx from "clsx";
import _ from "lodash";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  disabled?: boolean;
  additionalClassName?: string;
  children?: React.ReactNode;
  ["data-test-id"]?: string;
  layout?: boolean; // 重機配置の場合はボタンの色を変える
};

export const SubmitButton = ({
  loading,
  disabled,
  additionalClassName,
  children,
  onClick,
  layout,
  ...others
}: Props) => {
  const { t } = useTranslation();

  // 連打できない
  const handleClick = useMemo(() => _.throttle(onClick, 1000), [onClick]);
  const [minLoading, setMinLoading] = useState(false);

  return (
    <button
      {...others}
      type="button"
      className={clsx(
        "btn",
        additionalClassName,
        minLoading || loading ? "loading loading--button" : "",
        layout ? "bg-[#dea321] hover:bg-[#d3940a] hover:border-[#d3940a]" : "btn-blue"
      )}
      onClick={(e) => {
        handleClick(e);
        setMinLoading(true);
        setTimeout(() => setMinLoading(false), 300);
      }}
      disabled={minLoading || disabled || loading}
    >
      {children ?? t("save")}
    </button>
  );
};
